import { map } from 'rxjs/operators';
import { authActions } from 'src/app/core/auth/auth.actions';
import { AppState } from 'src/app/core/core.state';
import { ResourceEffects } from 'src/app/shared/resource-effects';

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { Agreement } from './agreement';
import { agreementActions } from './agreement.actions';
import * as fromAgreement from './agreement.reducer';
import { AgreementService } from './agreement.service';

@Injectable()
export class AgreementEffects extends ResourceEffects<Agreement> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public agreementService: AgreementService
  ) {
    super(
      fromAgreement.FEATURE_NAME,
      agreementService,
      agreementActions,
      actions$
    )
  }

  resetState = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.logout),
      map(() => agreementActions.resetState())
    )
  )
}
